export default "__VITE_ASSET__C6aD4TiH__"